<div class="searchable-select">
  <input type="text"
         class="searchable-select__input"
         autocomplete="off"
         [formControl]="searchControl"
         [placeholder]="placeholder"
         [matAutocomplete]="auto"
         [ngClass]="{'input-error': invalid}"
         [attr.data-field]="dataField"
         [attr.data-typeId]="dataTypeId"
         [attr.aria-label]="ariaLabel"
         [attr.tabIndex]="0"
         (blur)="onBlur()"
         (input)="filter($any($event.target).value)">

  @if (clearable && value && !disabled) {
    <button type="button"
            class="clear"
            i18n-title="@@searchable-select.clear"
            title="Clear selection"
            (click)="clear()">
      <i class="fas fa-times"></i>
    </button>
  }

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="display" (opened)="onOpened()" (closed)="restoreDisplay()"
                    (optionSelected)="onSelected($event.option.value)">
    @for (option of filtered; track option.value) {
      <!-- font-semibold is a global utility, so it also reaches the option inside the overlay -->
      <mat-option [value]="option"
                  [class.font-semibold]="isSelected(option)"
                  [class.searchable-select-option--priority]="option.priority">{{ option.label }}</mat-option>
    }
  </mat-autocomplete>
</div>
